type ValidateWorkflowArgs = {
  name: string;
  description: string;
};
export const validateWorkflow = ({ name, description }: ValidateWorkflowArgs) => {
  const errors: string[] = [];

  if (name === '') errors.push('Name is required');
  else if (name.length < 3) errors.push('Name must have at least 3 characters');

  if (description === '') errors.push('Description is required');
  else if (description.length < 3) errors.push('Description must have at least 3 characters');

  return errors;
};
